import React, { ReactNode } from "react";
import { Colors } from "../../../Constants/colors";

interface Props {
  children: ReactNode;
  style?: Object;
  key?: string;
}
export const ListTableCol = ({ children, style = {}, key = "" }: Props) => {
  return (
    <div
      className="w-full flex gap-2 items-center p-3"
      style={{
        border: `1px solid ${Colors.LightGrey}`,
        minHeight: "58px",
        gap: "20px",
        padding: "16px 18px",
        ...style,
      }}
    >
      {children}
    </div>
  );
};
